export default "__VITE_ASSET__DHyM_Qqi__"